export const INIT_SUBJECT_LIST = 'initSubjectList';
export const DISPATCH_INIT_SUBJECT_LIST = 'subject/initSubjectList';
